import styled from 'styled-components'

export const PageWrapper = styled.div`
	padding: 30px 300px 60px;
	min-width: 360px;
	display: flex;
	flex-direction: column;
	gap: 24px;

	@media (max-width: 1700px) {
		padding: 30px 220px 60px;
	}
	@media (max-width: 1550px) {
		padding: 30px 130px 60px;
	}
	@media (max-width: 1350px) {
		padding: 30px 80px 60px;
	}
	@media (max-width: 1250px) {
		padding: 30px 50px 60px;
	}
	@media (max-width: 1100px) {
		padding: 30px 20px 60px;
	}
	@media (max-width: 700px) {
		padding: 20px 12px 40px;
	}
`

export const Card = styled.div`
	background-color: #ffffff;
	border: 1px solid #f1ebeb;
	border-radius: 10px;
	padding: 24px 28px;
	box-shadow: 0 12px 32px 0 rgba(247, 139, 133, 0.1);
	display: flex;
	flex-direction: column;
	gap: 18px;

	@media (max-width: 700px) {
		padding: 20px;
	}
`

export const Header = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	gap: 16px;
	flex-wrap: wrap;

	h2 {
		font-size: 24px;
		font-weight: 600;
		letter-spacing: -1px;
		margin: 0;
		color: #222222;
	}

	p {
		font-size: 15px;
		color: #666666;
		margin: 4px 0 0 0;
	}

	.summary {
		font-size: 14px;
		color: #8a8a8a;
	}
`

export const SearchForm = styled.form`
	display: flex;
	align-items: center;
	gap: 12px;
	flex-wrap: wrap;

	input {
		flex: 1;
		min-width: 220px;
		height: 40px;
		border: 1px solid #dda8a8;
		border-radius: 6px;
		padding: 0 14px;
		background-color: #fff9f9;
		font-size: 14px;
		color: #222222;

		&::placeholder {
			color: #ba7070;
		}
	}

	select {
		height: 40px;
		min-width: 160px;
		border: 1px solid #dda8a8;
		border-radius: 6px;
		padding: 0 12px;
		background-color: #fff9f9;
		font-size: 14px;
		color: #222222;
	}

	button {
		height: 40px;
		padding: 0 18px;
		border-radius: 6px;
		border: none;
		background-color: #f78b85;
		color: #ffffff;
		font-weight: 600;
		letter-spacing: -0.5px;
		cursor: pointer;
		transition: background-color 0.2s ease;

		&:hover {
			background-color: #e3756f;
		}

		&:disabled {
			background-color: #eabfbd;
			cursor: not-allowed;
		}
	}
`

export const TableCard = styled(Card)`
	padding: 0;
	overflow: hidden;
`

export const TableWrapper = styled.div`
	width: 100%;
	overflow-x: auto;
`

export const UsersTable = styled.table`
	width: 100%;
	border-collapse: separate;
	border-spacing: 0;
	min-width: 720px;

	thead {
		background-color: #fae7e7;
	}

	th {
		padding: 14px 16px;
		font-size: 13px;
		font-weight: 500;
		color: #666666;
		text-align: left;
		border-bottom: 1px solid #f1ebeb;
	}

	td {
		padding: 14px 16px;
		font-size: 14px;
		color: #222222;
		border-bottom: 1px solid #f6f1f1;
		background-color: #ffffff;
	}

	tbody tr:hover {
		background-color: #fff5f5;
	}
`

export const ServiceCell = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	.switch-label {
		font-size: 13px;
		color: #666666;
		min-width: 42px;
	}
`

export const StatusBadge = styled.span<{ $active: boolean }>`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 4px 10px;
	border-radius: 999px;
	font-size: 12px;
	font-weight: 500;
	background-color: ${({ $active }) => ($active ? '#daf5e5' : '#ffe7cb')};
	color: ${({ $active }) => ($active ? '#056b2e' : '#d3490d')};
`

export const EmptyState = styled.div`
	padding: 32px 16px;
	text-align: center;
	color: #8a8a8a;
	font-size: 15px;
`

export const Footer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 18px 24px;
	border-top: 1px solid #f1ebeb;
	background-color: #fff9f9;
	flex-wrap: wrap;
	gap: 12px;

	.page-info {
		font-size: 14px;
		color: #8a8a8a;
	}
`

export const PaginationControls = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;

	button {
		min-width: 80px;
		height: 36px;
		padding: 0 14px;
		border-radius: 6px;
		border: 1px solid #e5d0d0;
		background-color: #ffffff;
		color: #666666;
		cursor: pointer;
		transition: all 0.2s ease;

		&:hover:not(:disabled) {
			background-color: #fae7e7;
			color: #d3490d;
		}

		&:disabled {
			cursor: not-allowed;
			opacity: 0.5;
		}
	}
`
